import { type Locale, SUPPORTED_LOCALES } from '@staiter/shared';
import { useContext } from 'react';
import { LocaleCtx } from '~/app/locale-context';

/** F-A.27 — единственный путь импорта useLocale. */
export function useLocale(): Locale {
  return useContext(LocaleCtx);
}

export function isSupportedLocale(x: unknown): x is Locale {
  return typeof x === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(x);
}
